import { render, staticRenderFns } from "./AccountVerified.vue?vue&type=template&id=61e2343a&scoped=true&"
import script from "./AccountVerified.vue?vue&type=script&lang=js&"
export * from "./AccountVerified.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerified.vue?vue&type=style&index=0&id=61e2343a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2343a",
  null
  
)

export default component.exports